'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _locations = require('../locations');

var _locations2 = _interopRequireDefault(_locations);

var _immutable = require('immutable');

var _schools = require('ifeis-isomorphic/lib/redux/actions/schools');

var _accounts = require('ifeis-isomorphic/lib/redux/actions/accounts');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.new-dependent', ['ngMaterial']).factory('fNewDependentDialog', function ($mdDialog, $mdMedia) {

  return function (ev, user, dependent) {
    return $mdDialog.show({
      controller: 'NewDependentDialogController',
      template: require('./tpl.html'),
      fullscreen: $mdMedia('xs'),
      targetEvent: ev,
      locals: {
        user: user,
        dependent: dependent ? angular.copy(dependent) : undefined,
        edit: !!dependent
      }
    });
  };
}).controller('NewDependentDialogController', function ($scope, $mdDialog, $ngRedux, dependent, edit, user, fLocationService) {
  var dependentInit = angular.copy(dependent);

  $scope.user = user;
  $scope.isModified = false;
  $scope.isSelectedSchoolListed = true;

  if (edit) {
    $scope.editing = edit;
    $scope.dependent = angular.copy(dependentInit);
  }

  // Get all schools from Redux store
  // TODO get my account details from the store ($scope.user) to avoid passing it from screens components

  $ngRedux.dispatch((0, _schools.getAllSchools)());
  $ngRedux.connect(function (state) {
    return {
      schools: (state.getIn(['schools', 'all']) || (0, _immutable.List)()).toJS()
    };
  })($scope);

  // On cancel

  $scope.cancel = function () {
    $mdDialog.cancel();
  };

  // On confirming the modal primary action

  $scope.confirm = function (d) {
    if ($scope.editing) {
      // edit existing dependent details
      if (dependentInit.fname !== d.fname || dependentInit.lname !== d.lname || dependentInit.dob !== d.dob || dependentInit.gender !== d.gender || dependentInit.champion !== d.champion) $ngRedux.dispatch((0, _accounts.updateDependent)($scope.user.id, d));

      // update school if it was modified
      if (dependentInit.school.id !== d.school.id) $ngRedux.dispatch((0, _accounts.setSchoolForDependent)($scope.user.id, d, d.school.id));
    } else {
      // create new dependent
      var dep = angular.copy(d);
      dep.school = d.school.id;
      $ngRedux.dispatch((0, _accounts.addDependent)($scope.user.id, dep));
    }

    $mdDialog.hide();
  };

  // Check if Dependent details were modified,
  // and activate Save button

  $scope.checkIfDirty = function () {
    return $scope.isModified = !angular.equals(dependentInit, $scope.dependent);
  };

  // Check if Dependent school is a "not-listed school",
  // and display a note to submit details

  $scope.checkIfSchoolNotListed = function (school) {
    var notListedSchoolId = 'myTRgQjfNeH';
    $scope.isSelectedSchoolListed = school.id !== notListedSchoolId;
  };

  // Prepare MailTo string
  // to submit a new school right from the modal

  $scope.mailToNewSchoolDetails = function () {
    return 'mailto:help@ifeis.net?\n            subject=Add%20New%20School\n            &body=%0AAdd%20New%20School%20to%20iFeis.net\n            %0A%0A\n            School Name:%20\n            %0A\n            School Address:%20\n            %0A\n            School Website:%20\n            %0A\n            Teacher\'s Name:%20\n            %0A%0A%0A\n            Submitted by ' + $scope.user.fname + ' ' + $scope.user.lname + ' (' + $scope.user.email + ').';
  };

  $scope.getAbbSchoolName = function (school) {
    var abbreviation = '';
    if (school.city) {
      abbreviation = ', ' + school.city;
    }
    if (school.state && school.country) {
      var countryCode = fLocationService.getCountryCode(school.country);
      var provinceCode = fLocationService.getProvinceCode(school.state, countryCode);
      abbreviation += ', ' + provinceCode + ', ' + countryCode;
    }
    return abbreviation;
  };
});


//////////////////
// WEBPACK FOOTER
// ./new-dependent/index.js
// module id = 485
// module chunks = 0